<template>
  <div class="checked_list">
    <div class="yxtbiz-area-selector__right_count">{{$t('pc_biz_shoptour_select_info' /*已选择（{0}/{1}）*/, [list.length, limit]).d(`已选择（${list.length}/${limit}）`)}}</div>
    <div class="checked_list_box" v-if="list.length > 0">
      <div style="height: 100%">
        <yxtbiz-virtual-list
          is-scrollbar
          style="height: 100%;overflow: hidden;"
          :data-sources="list"
          data-key="id"
          :estimate-size="32"
          :keeps="50"
          item-tag="div"
        >
          <template slot-scope="{ source }">
            <yxt-tag
              disable-transitions
              @close="clear(source)"
              size="mini"
              type="info"
              closable
              class="mb8 tag"
              :key="source.id"
            >
              <yxt-svg
                  class="mr5 v-mid"
                  width="14px"
                  height="14px"
                  icon-class="dept"
              />
              <span class="tag_span"> {{ source.areaName }}</span>
            </yxt-tag>
          </template>
        </yxtbiz-virtual-list>
      </div>
    </div>
    <yxt-empty v-else style="position:relative; top: calc(50% - 133px);" />

    <div class="operation">
      <yxt-button
        @click="clearAll"
        class="font-size-14 color-gray-9 hover-primary-6"
        type="text"
        :disabled="list.length === 0"
      >
        {{ $t('pc_biz_shoptour_clear_all').d('清除所有') }}
      </yxt-button>
    </div>
  </div>
</template>

<script>
/**
 * @description  : 已选择的区域(报表)
 * @date         : 2022-07-05 19:38:20
 * @author       : yokiizx
 */
export default {
  name: 'CheckedAreas',
  props: {
    // 已经勾选的区域
    list: {
      type: Array,
      default: () => []
    },
    // 最大选择区域树
    limit: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {};
  },

  methods: {
    /**
     * 清除所有
     */
    clearAll() {
      this.$emit('update:list', []);
    },
    /**
     * 关闭已选中标签
     */
    clear(data) {
      const res = this.list.filter(n => n.id !== data.id);
      this.$emit('update:list', res);
    }
  }
};
</script>
